import { useEffect } from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import { mergeClassnames } from '@mote/helpers/dom'
import { x } from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'
import { useDialogContext } from './DialogProvider'

export interface DialogHeaderProps extends HTMLXStyledProps<'header'> {}

export const DialogHeader = forwardRef<DialogHeaderProps, 'header'>(
  (props, ref) => {
    const { className, ...rest } = props

    const { headerId, setHeaderMounted } = useDialogContext()

    useEffect(() => {
      setHeaderMounted(true)
      return () => setHeaderMounted(false)
    }, [setHeaderMounted])

    const _className = mergeClassnames('mote-dialog__header', className)

    return (
      <x.header
        display='flex'
        flexDirection='row'
        alignItems='center'
        flex='0 1 0'
        pt={6}
        pb={4}
        px={6}
        text='lg'
        fontWeight='medium'
        color='black'
        {...rest}
        ref={ref}
        className={_className}
        id={headerId}
      />
    )
  }
)

if (__DEV__) {
  DialogHeader.displayName = 'DialogHeader'
}
